import VueObserveVisibility from 'vue3-observe-visibility';

export default defineNuxtPlugin(nuxtApp => {
	if (import.meta.client) {
		nuxtApp.vueApp.use(VueObserveVisibility);
	}
	else {
		nuxtApp.vueApp.directive('observe-visibility', {});
	}
});
